'use strict';

// window.addEventListener('scroll', () => {
//   if (window.scrollY > 0 && window.innerWidth >= 768) {
//     document.querySelectorAll('.product__slider__slide').forEach(slide => {
//       slide.style.height = '100vh';
//     });
//   }
// }, { passive: true, once: true });

var mainSwiper = new Swiper('.product__slider', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  },
  speed: 800,
  pagination: {
    el: '.swiper__navi__pagination',
    clickable: true
  }
});


  // MENU
document.querySelectorAll('.js-menu').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.toggle('is-menu');
    document.body.classList.remove('is-shop');

    // 1299px以下: .header__nav__product をスライドトグル
    if (window.innerWidth <= 1299) {
      $('.js-menu').toggleClass('is-active');
      $('.header__nav__product').slideToggle(300);
    }
  });
});

// MENU - SHOP
document.querySelectorAll('.js-shop').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.toggle('is-shop');
    document.body.classList.remove('is-menu');

    // 1299px以下: .header__nav__product をスライドトグル
    if (window.innerWidth <= 1299) {
      $('.js-shop').toggleClass('is-active');
      $('.header__nav__shop').slideToggle(300);
    }
  });
});

// MENU - FOOTER
document.querySelectorAll('.js-footer').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    //1300px以上はヘッダーの動作
    if (window.innerWidth >= 1300) {
      document.body.classList.toggle('is-shop');
      document.body.classList.remove('is-menu');
      document.body.classList.remove('is-footer');
    } else {
      document.body.classList.toggle('is-footer');
    }
  });
});

// MENU - OVERLAY
document.querySelectorAll('.header__nav__overlay').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.remove('is-shop');
    document.body.classList.remove('is-menu');
  });
});

// MENU - SP
document.querySelectorAll('.js-spmenu').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.toggle('is-opened');
    document.querySelectorAll('.link__rollover').forEach(function (el) {
      el.classList.remove('is-reset');
    });
  });
});

  // header
  const bar = document.querySelector('.bar');
const header = document.querySelector('.header');
const slides = document.querySelectorAll('.product__slider__slide');

const updateHeaderTop = () => {
  const barBottom = bar.getBoundingClientRect().bottom;
  header.style.top = Math.max(0, barBottom) + 'px';

  slides.forEach(slide => {
    slide.classList.toggle('is-fullheight', barBottom <= 0);
  });
};

window.addEventListener('load', updateHeaderTop);
window.addEventListener('scroll', updateHeaderTop, { passive: true });